<div class="patch-upload-wrapper modal-main-wrapper" [class.general-error]="!assetErrorText">
    <div class="close-container" tabindex="1">
        <div class="img-container">
            <img src="../../../../../assets/icons/Close.svg" (click)="cancel()">
        </div>
    </div>

    <div class="content-wrapper">
        <div class="img-container">
            <img class="icon" src="../../../../assets/icons/icon-warning.svg" alt="info">
        </div>
        <div class="summary-text-container">
            <span class="package-summary-span">{{assetErrorText}}</span>
            <span class="asset-warning-span" [innerHtml]="assetAdditionalErrorText"></span>
        </div>
    </div>
    <footer>
        <div class="button-wrapper">
            <button type="button" class="action-btn white-text cancel-button" (click)="cancel()" tabindex="7">
                OK
            </button>
        </div>
    </footer>
</div>